import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import NavBar from "../Components/NavBar";
import Footer from "../Components/Footer";
import SeoMeta from "../Components/SeoMeta";
import "./Landing.css";

// TODO: Replace static destination metadata with API-driven content when backend feed is available.
const destinations = [
  {
    id: "noida",
    title: "Noida",
    description:
      "Immerse yourself in urbane sophistication at Nimantrana Suites, the signature address in Noida.",
    path: "/noida",
    image: "https://nimantrana-media.s3.ap-south-1.amazonaws.com/aboutus5.jpg",
  },
  {
    id: "rishikesh",
    title: "Rishikesh",
    description:
      "Reconnect with nature at Moha by Nimantrana, a serene riverside sanctuary in the Himalayas.",
    path: "/destination",
    image: "/destination1.jpeg",
  },
];

function Landing() {
  const navigate = useNavigate();
  const location = useLocation();
  const canonicalUrl = `https://www.nimantrana.co.in${location.pathname || "/"}`;

  const landingSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Nimantrana Hospitality",
    "url": "https://www.nimantrana.co.in/",
    "description": "Discover curated luxury escapes in Noida and Rishikesh with Nimantrana."
  };

  // TODO: Surface seasonal offers once marketing assets are finalised.
  return (
    <div className="landing">
      <SeoMeta
        title="Luxury Hotel Stays in Noida & Rishikesh | Nimantrana"
        description="Discover curated luxury escapes in Noida and Rishikesh with Nimantrana suites, riverside retreats, and signature hospitality."
        canonical={canonicalUrl}
        keywords="Nimantrana, luxury hotel, Noida suites, Rishikesh resort, boutique stays"
        image="https://nimantrana-media.s3.ap-south-1.amazonaws.com/aboutus5.jpg"
        structuredData={landingSchema}
      />
      <NavBar />
      <section className="landing-hero">
        <div className="landing-hero__background"></div>
        <div className="landing-hero__overlay"></div>
        <div className="landing-hero__content">
          <div className="landing-hero__eyebrow">Welcome to Nimantrana</div>
          <h1 className="landing-hero__title">Choose Your Escape</h1>
          <p className="landing-hero__subtitle">
            Discover curated stays crafted for luxury seekers and nature lovers
            alike.
          </p>
          <div className="landing-cards">
            {destinations.map((destination) => (
              <button
                key={destination.id}
                type="button"
                className="landing-card"
                onClick={() => navigate(destination.path)}
              >
                <span
                  className="landing-card__background"
                  style={{ backgroundImage: `url(${destination.image})` }}
                ></span>
                <span className="landing-card__scrim"></span>
                <span className="landing-card__content">
                  <h2 className="landing-card__title">{destination.title}</h2>
                  <p className="landing-card__description">
                    {destination.description}
                  </p>
                  <span className="landing-card__cta">
                    Explore {destination.title}
                  </span>
                </span>
              </button>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default Landing;
